import { CONTEXT } from '../config/consts/commons';
import env from '../config/env';

const INTERCOM_VERTICAL = 'B2C';
const INTERCOM_USER_TYPE = 'CLOUDER';

const buildIntercomUserId = (username) => {
  if (!username) {
    return null;
  }

  return `${INTERCOM_VERTICAL.toLowerCase()}.${INTERCOM_USER_TYPE.toLowerCase()}.${username}`;
};

const loadIntercom = (appId) => {
  if (!appId) return;

  var w = window;
  var ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/' + appId;
      var x = d.getElementsByTagName('script')[0];
      if (x && x.parentNode) {
        x.parentNode.insertBefore(s, x);
      } else {
        d.head.appendChild(s);
      }
    };
    l();
  }
};

const intercomUtils = {
  closeIntercomConnection: () => {
    if (typeof window.Intercom !== 'function') return;
    window.Intercom('shutdown');
  },
  initiateIntercomConnection: () => {
    if (!env.INTERCOM_ID) return;

    window.intercomSettings = {
      app_id: env.INTERCOM_ID,
      email: localStorage.getItem('email'),
      user_id: buildIntercomUserId(localStorage.getItem('username')),
      username: localStorage.getItem('username'),
      created_at: Date.now(),
      user_type: INTERCOM_USER_TYPE,
      vertical: INTERCOM_VERTICAL,
      context: CONTEXT,
    };

    loadIntercom(env.INTERCOM_ID);
    window.Intercom('boot', window.intercomSettings);
  },
  setIntercomData: ({ email, clouderName, username }) => {
    localStorage.setItem('email', email);
    localStorage.setItem('clouderName', clouderName);
    localStorage.setItem('username', username);
  },
  setIntercomUsername: ({ username }) => {
    if (username) {
      localStorage.setItem('username', username);
    }
  },
};

export const {
  closeIntercomConnection,
  initiateIntercomConnection,
  setIntercomData,
  setIntercomUsername,
} = intercomUtils;

export { buildIntercomUserId };
